/**

The constants in this file should not be exported or used outside this library.
The values here are meant for aligning across components internally.

 */

export var ButtonStyles = {
  transitionBehaviour: "150ms ease-out",
  fastTransitionBehaviour: "100ms ease-out",
  primary: {
    hover: "#2b70ac"
  },
  success: {
    hover: "#0b8c5d"
  },
  critical: {
    hover: "#c93c4a"
  }
};

// // Color variations not included in UI kit

export var ColorVariations = {
  darkBlue: "#2471b3",
  primaryBlueOpacity: "rgba(54, 140, 215, .07)",
  cardBorderGrayOpacity: "rgba(223, 226, 229, .6)"
};
export var CheckControlStates = {
  labelColor: "var(--CDS-color-semantic-surface-foreground-default)",
  labelColorDisabled: "var(--CDS-color-semantic-surface-foreground-disabled)",
  "default": {
    background: "var(--CDS-color-semantic-surface-default)",
    borderRadius: "var(--CDS-border-radius-s)",
    border: "1px solid var(--CDS-color-semantic-surface-foreground-subtle)"
  },
  defaultHover: {
    borderColor: "var(--CDS-color-semantic-surface-foreground-default)",
    backgroundColor: "var(--CDS-color-semantic-actions-surface-hover)"
  },
  defaultFocus: {
    borderColor: "var(--CDS-color-semantic-surface-foreground-default)",
    outline: "2px solid var(--CDS-color-semantic-actions-default)",
    outlineOffset: 2
  },
  defaultActive: {
    backgroundColor: "var(--CDS-color-semantic-actions-surface-active)"
  },
  defaultDisabled: {
    cursor: "not-allowed",
    border: "transparent",
    backgroundColor: "var(--CDS-color-semantic-surface-foreground-disabled)"
  },
  checked: {
    borderColor: "var(--CDS-color-semantic-actions-default)",
    backgroundColor: " var(--CDS-color-semantic-actions-surface)",
    boxShadow: "none"
  },
  checkedHover: {
    borderColor: "var(--CDS-color-semantic-surface-foreground-default)",
    backgroundColor: "var(--CDS-color-semantic-actions-surface-hover)"
  },
  checkedFocus: {
    borderColor: "var(--CDS-color-semantic-surface-foreground-default)",
    outline: "2px solid var(--CDS-color-semantic-actions-default)",
    outlineOffset: 2
  },
  checkedActive: {
    backgroundColor: "var(--CDS-color-semantic-actions-surface-active)"
  },
  checkedDisabled: {
    cursor: "not-allowed",
    border: "transparent",
    backgroundColor: "var(--CDS-color-semantic-surface-foreground-disabled)"
  }
};
export var zIndexLevels = {
  modalBackdrop: 101,
  modalContent: 102,
  popover: 102,
  selectMenu: 110,
  globalAlert: 999,
  pageLoaderBackdrop: 9998,
  pageLoaderContent: 9999
};